angular.module 'zc.core'

.filter "zerosForMissingTime", ($filter) ->
  DAILY_INTERVAL = 24*60*60*1000
  HOURLY_INTERVAL = 60*60*1000

  dimensions =
    hourly:
      singular: 'hour'
      plural: 'hours'
      interval: HOURLY_INTERVAL
    daily:
      singular: 'day'
      plural: 'days'
      interval: DAILY_INTERVAL

  (array, dimension, opts = {}) ->

    opts = _.merge({
      start_at_key: 'start_at',
      end_at_key: 'end_at',
    }, opts)

    return array if !array.length?
    return array if array.length == 0
    return array if not _.has(dimensions, dimension)

    currentDimension = dimensions[dimension]

    # just in case that array is not already sorted, do initial sort!!
    array = _.sortBy(array, (o) -> o[opts.start_at_key])

    toBeAdded = []
    lastDate = undefined

    convertTo = 'date'
    if typeof array[0][opts.start_at_key] == 'number'
      convertTo = 'number'

    # get all keys
    allKeys = _.chain(array)
      .map((obj) -> Object.getOwnPropertyNames(obj))
      .flatten()
      .union()
      .value()

    createObj = (start_at, end_at) ->
      newObj = {}
      for key in allKeys
        newObj[key] = 0
      newObj[opts.start_at_key] = start_at
      newObj[opts.end_at_key] = end_at
      newObj


    addZerosForPeriod = (start_at, end_at) ->
      diffInMilliseconds = moment(end_at).valueOf() - moment(start_at).valueOf()

      # do not add if it's less than dimensions' interval
      if diffInMilliseconds > currentDimension.interval
        # how many units (days/hours) there is between
        diffInTimeUnits = diffInMilliseconds / currentDimension.interval

        # create object for each missing unit between
        for timeCounter in [1..(diffInTimeUnits - 1)]
          startAt = moment(start_at).add(timeCounter, currentDimension.plural).valueOf()
          endAt = moment(startAt).endOf(currentDimension.singular).valueOf()
          toBeAdded.push createObj(startAt, endAt)

    # go through all depending on dimension and add zeros if there's larger
    # than one interval period
    for obj in array
      if lastDate
        addZerosForPeriod(lastDate, obj[opts.start_at_key])

      lastDate = obj[opts.start_at_key]

    # If there is forced start_at or end_at, we want to add leading or trailing
    # zeros also
    if opts.start_at
      beforeStartAt = moment(opts.start_at).diff(moment(array[0][opts.start_at_key]))
      if beforeStartAt != 0
        # subtract 1 hour from start, because we will want the hour starting
        # from that also!
        addZerosForPeriod(moment(opts.start_at).subtract(1, currentDimension.plural), moment(array[0][opts.start_at_key]))

    if opts.end_at
      afterEndAt = moment(moment(array[0][opts.end_at_key])).diff(opts.end_at)
      if afterEndAt != 0
        # end_at is like xx:59:59 so start of hour
        if dimension == 'hourly' && moment().startOf('day').isSame(moment(opts.end_at).startOf('day'))
          # in case of hourly, make it until beginning of current hour
          addZerosForPeriod(
            moment(array[array.length - 1][opts.end_at_key]).startOf(currentDimension.singular),
            moment(opts.end_at).hour(moment().hour()).startOf(currentDimension.singular)
          )
        else
          addZerosForPeriod(
            moment(array[array.length - 1][opts.end_at_key]).startOf(currentDimension.singular),
            moment(opts.end_at).add(1, currentDimension.singular).startOf(currentDimension.singular)
          )


    # insert for empty dates 0 values for all keys
    array = _.chain(array)
      .union(toBeAdded)
      .sortBy((o) -> o[opts.start_at_key])
      .map((o) ->
        if convertTo == 'date'
          o[opts.start_at_key] = new Date(o[opts.start_at_key])
          o[opts.end_at_key] = new Date(o[opts.end_at_key])
        o
      )
      .value()

    return array



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/zeros_for_missing_time.coffee